enum WorkSafeBcCodeDictionaryType {
    BodyParts,
    NatureOfInjury
}

export { WorkSafeBcCodeDictionaryType };
